import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { categoriesApi } from "./api";
import { productKeys } from "../products/hooks";
import type { ProductVisualKey } from "@ventas/shared";

export const categoryKeys = { all: ["categories"] as const };

export function useCategoryList(active?: boolean, search?: string) {
  return useQuery({
    queryKey: [...categoryKeys.all, { active, search }],
    queryFn: () => categoriesApi.list({ active, search }),
  });
}

export function useCreateCategory() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: categoriesApi.create,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: categoryKeys.all });
      client.invalidateQueries({ queryKey: productKeys.all });
    },
  });
}

export function useUpdateCategory() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: Partial<{ name: string; iconKey: ProductVisualKey; active: boolean }> }) => categoriesApi.update(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: categoryKeys.all });
      client.invalidateQueries({ queryKey: productKeys.all });
    },
  });
}
